export default __webpack_public_path__ + "static/media/CGarticle.723d2e0d.png";